import { StyleSheet, Text, View, Image } from 'react-native'
import React from 'react'

const WelcomeThird = () => {
  return (
    // <>
    //   <Text
    //     style={{
    //       fontWeight: 'bold',
    //       fontSize: 27,
    //       color: 'white',
    //       alignSelf: 'center'
    //     }}
    //   >
    //     Shift Schedule
    //   </Text>

    //   {/* <Text
    //     style={{
    //       fontSize: 17,
    //       color: 'white',
    //       alignSelf: 'center',
    //       marginTop: '5%'
    //     }}
    //   >
    //     Fill out your default schedule so that{' '}
    //   </Text>
    //   <Text style={{ fontSize: 17, color: 'white', alignSelf: 'center' }}>
    //     managers have a starting point for
    //   </Text>
    //   <Text style={{ fontSize: 17, color: 'white', alignSelf: 'center' }}>
    //     scheduling.
    //   </Text> */}

    //   <View style={[styles.rectangle]}>
    //     <Image
    //       source={require('../../../static/images/Welcome-Myshift.png')}
    //       style={[styles.appBrand]}
    //       resizeMode="contain"
    //     />
    //   </View>
    // </>
    <>
      {/* <Text
            style={{
      fontWeight: 'bold',
      fontSize: 27,
      color: 'white',
      alignSelf: 'center'
    }}
> Shift Schedule</Text>
     <Image
      source={require('../../../static/images/Welcome-Myshift.png')}
      style={[styles.appBrand]}
      resizeMode="contain"
    /> */}
      <Text
        style={{
          fontWeight: 'bold',
          fontSize: 27,
          color: 'white',
          alignSelf: 'center'
        }}
      > Login</Text>

      <Image
        source={require('../../../static/images/Welcome-LoginPassword.png')}
        style={[styles.appBrand]}
        resizeMode="contain"
      />

    </>
  )
}

export default WelcomeThird

const styles = StyleSheet.create({
  rectangle: {
    alignSelf: 'center',
    marginTop: '20%',
    width: '30%',
    height: '64%',
    //backgroundColor: 'white',
    borderRadius: 15
  },
  appBrand: {
    width: '50%',
    height: '70%',
    alignSelf: 'center'
    // marginTop:'10%'
  }
})
